import { putAction, getAction } from '@/api/manage';
export default {
  name: "Step3",
  //    components: {
  //      Result
  //    },
  props: ['userList'],
  data: function data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      accountName: this.userList.username,
      validatorRules: {
        username: {
          rules: [{
            required: true,
            message: '用户名不能为空!'
          }]
        },
        password: {
          rules: [{
            required: true,
            pattern: /^[\w]{6,}$/,
            message: '密码为6位数字、字母组合，建议区分大小写。'
          }, {
            validator: this.handlePasswordLevel
          }]
        },
        confirmPassword: {
          rules: [{
            required: true,
            message: '密码不能为空!'
          }, {
            validator: this.handlePasswordCheck
          }]
        }
      }
    };
  },
  methods: {
    nextStep: function nextStep() {
      var _this = this;
      var that = this;
      that.loading = true;
      this.form.validateFields(function (err, values) {
        if (!err) {
          var params = {};
          params.username = _this.userList.username;
          params.password = values.password;
          params.smscode = _this.userList.smscode;
          params.phone = _this.userList.phone;
          getAction("/sys/user/passwordChange", params).then(function (res) {
            if (res.success) {
              var userList = {
                username: _this.userList.username
              };
              console.log(userList);
              setTimeout(function () {
                that.$emit('nextStep', userList);
              }, 1500);
            } else {
              _this.passwordFailed(res.message);
              that.loading = false;
            }
          });
        } else {
          that.loading = false;
        }
      });
    },
    prevStep: function prevStep() {
      this.$emit('prevStep', this.userList);
    },
    handlePasswordCheck: function handlePasswordCheck(rule, value, callback) {
      var password = this.form.getFieldValue('password');
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error('两次密码不一致'));
      }
      callback();
    },
    passwordFailed: function passwordFailed(err) {
      this.$notification['error']({
        message: "更改密码失败",
        description: err,
        duration: 4
      });
    }
  }
};